import Link from "next/link";

export default function Footer() {
  return (
    <footer className="py-12 bg-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link href="/" className="flex items-center gap-3 cursor-pointer">
            <img src="/logo.png" alt="Contract Lucidity" className="h-10" />
          </Link>
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-400" style={{ fontFamily: "system-ui, sans-serif" }}>
            <Link href="/features" className="hover:text-[#1B3A6B] transition-colors">Features</Link>
            <Link href="/how-it-works" className="hover:text-[#1B3A6B] transition-colors">How It Works</Link>
            <Link href="/law-firms" className="hover:text-[#1B3A6B] transition-colors">Law Firms</Link>
            <Link href="/in-house" className="hover:text-[#1B3A6B] transition-colors">In-House</Link>
            <Link href="/security" className="hover:text-[#1B3A6B] transition-colors">Security</Link>
            <Link href="/why-contract-lucidity" className="hover:text-[#1B3A6B] transition-colors">Why Us</Link>
            <a href="https://lucidvault.contractlucidity.com" target="_blank" rel="noopener noreferrer" className="text-[#C8A84B] hover:text-[#b8993f] font-semibold transition-colors">Lucid Vault</a>
            <Link href="/login" className="hover:text-[#1B3A6B] transition-colors">Sign In</Link>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-50 text-center">
          <p className="text-xs text-gray-300" style={{ fontFamily: "system-ui, sans-serif" }}>Powered by AI. Guided by attorneys.</p>
        </div>
      </div>
    </footer>
  );
}
